import { AuthContainer } from './AuthContainer';

export default AuthContainer;
